import type { IHouseholdExpense } from './HouseholdExpense.interface';
import { PaymentFrequency } from '../global/PaymentFrequency.enum';
import { HouseholdExpenseType } from './HouseholdExpense.enum';

export default class HouseholdExpense implements IHouseholdExpense {
  type: HouseholdExpenseType;
  frequency: PaymentFrequency;
  value: number;
  comments: string;

  static build = (data: IHouseholdExpense) => new HouseholdExpense(data);
  static blank = () => new HouseholdExpense();

  /**
   * Constructor
   * @param {IHouseholdExpense} data
   */
  constructor(data?: IHouseholdExpense) {
    this.type = HouseholdExpenseType.of(data?.type?.name);
    this.frequency = PaymentFrequency.of(data?.frequency?.name || this?.type?.frequency);
    this.value = parseFloat(data?.value || 0);
    this.comments = data?.comments || '';
  }
}
